import Collection from '../../collection';
import Rule from '../../model/access/rule'

import { hashify } from '../../utils/arrays';





export default Collection.extend( {
    endpoint: 'tasks/rules/all?apiVersion=2.0',
    responseAt: 'items',
    model: Rule,

    initialize(items, options) {
        Collection.prototype.initialize.call( this, items, options );

        if (options.capabilities)
            this.options.capabilities = hashify( options.capabilities.toJSON(),
                capability => [capability.id, capability] );

        if (options.roles)
            this.options.roles = hashify( options.roles.toJSON(),
                role => [role.id, role] );

        if (options.states)
            this.options.states = hashify( options.states.toJSON(),
                state => [state.id, state] );
    },

    parseResponse(attrsList/*, response*/) {
        return attrsList.map( attrs => {
            let { capability_id, role_id, states } = attrs;
            let capability, role;

            if (this.options.capabilities)
                capability = this.options.capabilities[capability_id];

            if (this.options.roles) 
                role = this.options.roles[role_id];

            if (this.options.states)
                states = (states || []).map( id => this.options.states[id] );
            
            return { 
                ...attrs,
                capability,
                role,
                states, 
            };
        } );
    }
} );


// WEBPACK FOOTER //
// ./src/js/collection/access/rules.js